import { Button } from "antd";
import { Item } from "../../../services/Item";

const tables = [
    { key: 'tablePlanning', name: 'Planning and Preparatory stage' },
    { key: 'tableBids', name: 'Bids Solicitation' },
    { key: 'tableEvaluation', name: 'Evaluation' },
    { key: 'tableCommitteeReview', name: 'Committee Review' },
    { key: 'tableContractAward', name: 'Contract Award' },
    { key: 'tableContractManagement', name: 'Contract Management' }
];

const StagesList = ({ item }: { item: Item }) => {
    const scrollTable = (id: string) => {
        document?.getElementById(id)?.scrollIntoView();
    }
    return (
        <ul>
            {tables.map(table => {
                const tableData = item[table.key as keyof Item];
                if (Array.isArray(tableData) && tableData.length !== 0) {
                    return (
                        <li key={table.key}>
                            <Button onClick={() => scrollTable(table.name)} type="link">
                                {table.name}
                            </Button>
                        </li>
                    );
                }
                return null;
            })}
        </ul>
    );
};

export default StagesList;

